export const replaceCopyKey = (text, key, value) => {
  const formattedKey = `{${key}}`;
  const escapedKey = formattedKey.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  const regex = new RegExp(escapedKey, 'g');

  if (text.includes(formattedKey)) {
    return text.replace(regex, value);
  }

  // removes {KEY} from the copy
  const looseRegex = new RegExp(`{\\s*${key}\\s*}`, 'g');

  return text.replace(looseRegex, key);
};
